import React from 'react';
import Filters from './../Filters';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { T } from '../../components/Translations';
/**
 * the wrapper of main list pages with filters
 * @param {any} props
 */
export default function MainListWrapper(props) {
    const { children, filters, newButton, appliedFilter, setAppliedFilter, loadData, clearFilter, showRefreshButton, pagination, setPagination, isListView, exportData } = props;


    return isListView ?
        <view>
            {(showRefreshButton || filters) && <toolbar>
                {filters && <action>
                    <div className='button'><text><T>text.filter</T></text></div>
                </action>}
                {showRefreshButton && <action right=""
                >
                    <div onClick={loadData} className={'button'}
                    ><text><T>text.refresh</T></text></div>
                </action>}

            </toolbar>}
            {children}
        </view> :
        <container>

            <view vertical='' adaptive=''
            >
                {filters && <Filters
                    clear={clearFilter}
                    appliedFilter={appliedFilter}
                    filters={filters}
                    setAppliedFilter={setAppliedFilter}
                    setPagination={setPagination}
                    pagination={pagination}
                />}
                <view>{(showRefreshButton || exportData) &&

                    <toolbar>
                        {showRefreshButton && <Tooltip title={<T>text.refresh</T>}>
                            <div className='button accent' onClick={loadData}
                            ><text><T>text.refresh</T></text></div>
                        </Tooltip>}
                        {exportData &&
                            <Tooltip title={<T>text.export</T>}>
                                <action right=""
                                >
                                    <div onClick={exportData} className={'button primary'}
                                    ><text><T>text.export</T></text></div>
                                </action>
                            </Tooltip>}
                    </toolbar>}
                    {newButton}
                    {children}
                </view>
            </view>
        </container>;
}


MainListWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    filters: PropTypes.array,
    newButton: PropTypes.node,
    appliedFilter: PropTypes.object,
    setAppliedFilter: PropTypes.func,
    loadData: PropTypes.func,
    clearFilter: PropTypes.func,
    showRefreshButton: PropTypes.bool,
    pagination: PropTypes.object,
    setPagination: PropTypes.func,
    isListView: PropTypes.bool,
    exportData: PropTypes.func
};

MainListWrapper.defaultProps = {
    filters: null,
};